import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_10.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/drive');
  const shareText = encodeURIComponent(' Where Values Drive Engagement and Growth!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Drive Engagement — Outstanding Workplaces</title>
        <meta property="og:title" content="Drive Engagement — Outstanding Workplaces" />
        <meta property="og:description" content=" Where Values Drive Engagement and Growth" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778042695/i_10_slpeok.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/drive" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Drive Engagement — Outstanding Workplaces" />
        <meta name="twitter:description" content="Where Values Drive Engagement and Growth" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778042695/i_10_slpeok.jpg" />
      </Helmet>

       <div className="sight_10_page_wrapper">
      <div className="sight_10_content_container">

        <div className="sight_10_section_one">

          {/* TITLE */}
          <h1 className="sight_10_page_title">
            Where Values Drive Engagement and Growth
          </h1>

          {/* ROW */}
          <div className="sight_10_row">

            {/* LEFT SIDE */}
            <div className="sight_10_left">
              <div className="sight_10_image_wrapper">
                <img
                  src="/assets/i_10.jpg"
                  alt="Team meeting discussion"
                  className="sight_10_blog_image"
                />
              </div>


                {/* SHARE SECTION */}
                <div className="sight_10_share_section">
                  <span className="sight_10_share_text">Share :</span>
                  <div className="sight_10_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_10_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_10_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_10_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_10_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

            <p className="sight_10_intro_paragraph">
                Company culture is the heart of employer branding. It reflects your organization’s values, behaviors, and work environment, shaping how employees experience the workplace. A strong, positive culture not only attracts top talent but also retains them, increases engagement, and enhances your company’s reputation externally.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_10_right">
              <div className="sight_10_ad_card">
                <img src="/assets/bc_1.png" className="sight_10_ad_bg" />
                <div className="sight_10_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_10_ad_badge" />

                <div className="sight_10_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_10_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_10_section">

          <ul className="sight_10_intro_list">
            <li>
              By showcasing authentic company culture through stories, employee testimonials, and workplace initiatives, organizations communicate their unique value proposition to potential candidates. In essence, employer branding is the visible expression of a company’s culture—when culture and branding align, your organization becomes a magnet for the right talent.
            </li>
          </ul>

          <div className="sight_10_topics">

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                Why Company Culture is the Heart of Employer Branding
              </h2>
              <ul className="sight_10_topic_list">
                <li>Explore how a strong internal culture directly influences external reputation and attracts top talent.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                5 Ways to Showcase Your Company Culture Online
              </h2>
              <ul className="sight_10_topic_list">
                <li>Practical tips for using social media, website, and blogs to highlight values, teamwork, and innovation.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                The Role of Leadership in Shaping Company Culture
              </h2>
              <ul className="sight_10_topic_list">
                <li>How leaders set the tone, influence employee engagement, and strengthen employer brand.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                Employee Stories: Bringing Your Culture to Life
              </h2>
              <ul className="sight_10_topic_list">
                <li>Using real employee experiences to make your employer brand authentic and relatable.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                Cultural Fit vs. Cultural Add: What Matters for Branding
              </h2>
              <ul className="sight_10_topic_list">
                <li>Discuss the difference and how hiring for cultural add enhances company reputation.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                How Recognition and Rewards Strengthen Your Employer Brand
              </h2>
              <ul className="sight_10_topic_list">
                <li>Showcasing internal recognition programs as a reflection of values and culture.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                Building a Culture That Attracts Diverse Talent
              </h2>
              <ul className="sight_10_topic_list">
                <li>Linking inclusive culture practices to employer branding and talent acquisition.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                From Onboarding to Advocacy: Culture as a Branding Tool
              </h2>
              <ul className="sight_10_topic_list">
                <li>How a culture-focused onboarding experience turns employees into brand ambassadors.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                Metrics That Matter: Measuring Culture Impact on Employer Brand
              </h2>
              <ul className="sight_10_topic_list">
                <li>Tools and KPIs to track how company culture enhances recruitment and retention.</li>
              </ul>
            </div>

            <div className="sight_10_topic_item">
              <h2 className="sight_10_topic_heading">
                Case Studies: Companies That Nailed Culture-Driven Employer Branding
              </h2>
              <ul className="sight_10_topic_list">
                <li>Real-world examples of organizations using culture to boost reputation and attract talent.</li>
              </ul>
            </div>

          </div>
        </div>

       </div>
   </div>
    </>
  );
}

export default BlogPage;
